import React from 'react';
import SectionEdition, { Slot } from './SectionEdition';

// Tiny demo component used only by the ui-kit page. Renders a SectionEdition
// with three pre-baked Slots so the layout (top divider, 98px min-height,
// trailing edit/delete actions, inherited context + delete confirmation)
// is visible in the styleguide. Functions are no-ops because Rails
// `react_component` can't serialise handlers through JSON.

const noop = () => undefined;

const SlotDemo: React.FC = () => (
  <SectionEdition
    title="Languages"
    iconName="globe"
    context="talent"
    onAdd
    allowMultiple
    defaultDeleteConfirmation={{
      title: 'Remove this language?',
      message: "You'll be able to add it back later.",
    }}
  >
    <Slot>English — Native or bilingual</Slot>
    <Slot label="Portuguese" onEdit={noop}>
      Portuguese — Native
    </Slot>
    <Slot label="Spanish" onEdit={noop} onDelete={noop}>
      Spanish — Limited working
    </Slot>
  </SectionEdition>
);

export default SlotDemo;
